const { languages } = require('../../locales');

function getLanguagesGroupedByRegion() {
  return languages.reduce((result, language) => {
    if (language.region) {
      if (!result[language.region]) {
        // eslint-disable-next-line no-param-reassign
        result[language.region] = [];
      }
      result[language.region].push(language);
    }
    return result;
  }, {});
}

module.exports = {
  getLanguagesGroupedByRegion,
};
